import { RazorInputField } from "../../razor-reuse";
import { useContext } from "react";
import { reactSelectStyleTable } from "../../../utils/Helper";
import "./styles/PerpageComp.css";
import ActionContext from "../../../context/ActionContext";

export const dropListPerPage = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "150", value: 150 },
  { label: "200", value: 200 },
  { label: "250", value: 250 },
  { label: "500", value: 500 },
  { label: "1000", value: 1000 },
];

const PerpageComp = () => {
  const actionCtx = useContext(ActionContext);

  return (
    <div className="reuseable-per-page-main-wrapper-comp-box">
      <RazorInputField
        selectOption={dropListPerPage}
        selectStyles={reactSelectStyleTable}
        type={`select`}
        className={`select-class`}
        menuPlacement={`top`}
        placeholder=" "
        value={actionCtx?.perPage}
        onChange={(e: any) => {
          actionCtx?.setPerPage && actionCtx?.setPerPage(e);
        }}
      />
    </div>
  );
};

export default PerpageComp;
